import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class SpiderMenuButton extends Vue {

    @Prop({ default: true })
    private visible!: boolean

    private view: 'both' | 'first' | 'second' = 'both'

    private select(view: 'both' | 'first' | 'second') {
        this.view = view
        this.$emit('click', view)
    }
}
